import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type FileServiceGetUploadLinksMutationVariables = Types.Exact<{
  input: Types.GetUploadLinksInput;
}>;


export type FileServiceGetUploadLinksMutation = { __typename?: 'Mutation', FileService: { __typename?: 'FileServiceMutations', getUploadLinks: Array<{ __typename: 'UploadLinkError', fileName: string, errorMessage: string } | { __typename: 'UploadLinkSuccess', fileName: string, uploadLink: string, fileUuid: string }> } };

export type FileServiceGetFileMetadataQueryVariables = Types.Exact<{
  input: Types.GetFileMetadataInput;
}>;


export type FileServiceGetFileMetadataQuery = { __typename?: 'Query', FileService: { __typename?: 'FileServiceQueries', getFileMetadata: Array<{ __typename: 'FileMetadataError', uuid: string, errorMessage: string, errorCode?: Types.FileMetadataErrorCode | null } | { __typename: 'FileMetadataSuccess', uuid: string, filename?: string | null, expiresOn?: string | null, status?: string | null, downloadLink?: string | null }> } };

export type FileServiceDeleteFilesMutationVariables = Types.Exact<{
  input: Types.DeleteFilesInput;
}>;


export type FileServiceDeleteFilesMutation = { __typename?: 'Mutation', FileService: { __typename?: 'FileServiceMutations', deleteFiles: Array<{ __typename: 'DeleteFileError', fileUuid: string, isSuccess: boolean, errorMessage: string } | { __typename: 'DeleteFileSuccess', fileUuid: string, isSuccess: boolean }> } };

export type FileServiceGetServiceUrlQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FileServiceGetServiceUrlQuery = { __typename?: 'Query', FileService: { __typename?: 'FileServiceQueries', getServiceUrl: { __typename?: 'ServiceUrlResult', serviceUrl: string, resourcePath: string, region: string } } };


export const FileServiceGetUploadLinksDocument = `
    mutation fileServiceGetUploadLinks($input: GetUploadLinksInput!) {
  FileService {
    getUploadLinks(input: $input) {
      __typename
      ... on UploadLinkSuccess {
        fileName
        uploadLink
        fileUuid
      }
      ... on UploadLinkError {
        fileName
        errorMessage
      }
    }
  }
}
    `;
export const FileServiceGetFileMetadataDocument = `
    query fileServiceGetFileMetadata($input: GetFileMetadataInput!) {
  FileService {
    getFileMetadata(input: $input) {
      __typename
      ... on FileMetadataSuccess {
        uuid
        filename
        expiresOn
        status
        downloadLink
      }
      ... on FileMetadataError {
        uuid
        errorMessage
        errorCode
      }
    }
  }
}
    `;
export const FileServiceDeleteFilesDocument = `
    mutation fileServiceDeleteFiles($input: DeleteFilesInput!) {
  FileService {
    deleteFiles(input: $input) {
      __typename
      ... on DeleteFileSuccess {
        fileUuid
        isSuccess
      }
      ... on DeleteFileError {
        fileUuid
        isSuccess
        errorMessage
      }
    }
  }
}
    `;
export const FileServiceGetServiceUrlDocument = `
    query fileServiceGetServiceUrl {
  FileService {
    getServiceUrl {
      serviceUrl
      resourcePath
      region
    }
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    fileServiceGetUploadLinks: build.mutation<FileServiceGetUploadLinksMutation, FileServiceGetUploadLinksMutationVariables>({
      query: (variables) => ({ document: FileServiceGetUploadLinksDocument, variables })
    }),
    fileServiceGetFileMetadata: build.query<FileServiceGetFileMetadataQuery, FileServiceGetFileMetadataQueryVariables>({
      query: (variables) => ({ document: FileServiceGetFileMetadataDocument, variables })
    }),
    fileServiceDeleteFiles: build.mutation<FileServiceDeleteFilesMutation, FileServiceDeleteFilesMutationVariables>({
      query: (variables) => ({ document: FileServiceDeleteFilesDocument, variables })
    }),
    fileServiceGetServiceUrl: build.query<FileServiceGetServiceUrlQuery, FileServiceGetServiceUrlQueryVariables | void>({
      query: (variables) => ({ document: FileServiceGetServiceUrlDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useFileServiceGetUploadLinksMutation, useFileServiceGetFileMetadataQuery, useLazyFileServiceGetFileMetadataQuery, useFileServiceDeleteFilesMutation, useFileServiceGetServiceUrlQuery, useLazyFileServiceGetServiceUrlQuery } = injectedRtkApi;

